// src/context/OrgContext.jsx
import { createContext, useContext, useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../api/axios';
import { useAuth } from '../auth/useAuth';

const OrgCtx = createContext(null);

export function OrgProvider({ children }) {
  const { user, isAuthenticated } = useAuth();
  const { t } = useTranslation('org');
  const [org,     setOrg]     = useState(null);
  const [orgs,    setOrgs]    = useState([]);  // super_admin uniquement
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || !user?.org_id) return;
    setLoading(true);
    api.get('/orgs/me')
      .then(r => setOrg(r.data))
      .catch(() => setOrg({ id: user.org_id, name: t('myOrg') }))
      .finally(() => setLoading(false));
  }, [isAuthenticated, user?.org_id, t]);

  useEffect(() => {
    if (!user?.isSuperAdmin) return;
    api.get('/orgs/?limit=100')
      .then(r => setOrgs(r.data?.orgs || r.data || []))
      .catch(() => setOrgs([]));
  }, [user?.isSuperAdmin]);

  const switchOrg = (orgId) => {
    const found = orgs.find(o => o.id === orgId);
    if (found) setOrg(found);
  };

  const value = useMemo(() => ({
    org,
    orgs,
    loading,
    switchOrg,
    orgId:   org?.id   || user?.org_id || null,
    orgName: org?.name || null,
  }), [org, orgs, loading, user?.org_id]);

  return <OrgCtx.Provider value={value}>{children}</OrgCtx.Provider>;
}

export function useOrg() {
  return useContext(OrgCtx);
}
